import { useFormikContext } from "formik";
import { Form } from "react-bootstrap";
import { RegisterFormModel } from "../../../types/Register/RegisterFormModel";
import ValidatingPasswordInput from "./VaildatingPasswordInput";

const PersonalDetailsForm = () => {
  const { handleChange, values, touched, errors, handleBlur } =
    useFormikContext<RegisterFormModel>();

  return (
    <>
      <Form.Group className="mb-3">
        <Form.Label className="mb-0">First name</Form.Label>
        <Form.Control
          type="input"
          onChange={handleChange}
          value={values.personalDetails.firstName}
          isInvalid={
            touched.personalDetails?.firstName &&
            !!errors.personalDetails?.firstName
          }
          onBlur={handleBlur}
          name="personalDetails.firstName"
        />
        <Form.Control.Feedback type="invalid">
          {errors.personalDetails?.firstName}
        </Form.Control.Feedback>
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label className="mb-0">Second name</Form.Label>
        <Form.Control
          type="input"
          onChange={handleChange}
          value={values.personalDetails?.secondName}
          isInvalid={
            touched.personalDetails?.secondName &&
            !!errors.personalDetails?.secondName
          }
          onBlur={handleBlur}
          name="personalDetails.secondName"
        />
        <Form.Control.Feedback type="invalid">
          {errors.personalDetails?.secondName}
        </Form.Control.Feedback>
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label className="mb-0">Username</Form.Label>
        <Form.Control
          type="input"
          onChange={handleChange}
          value={values.personalDetails?.userName}
          isInvalid={
            touched.personalDetails?.userName &&
            !!errors.personalDetails?.userName
          }
          onBlur={handleBlur}
          name="personalDetails.userName"
        />
        <Form.Control.Feedback type="invalid">
          {errors.personalDetails?.userName}
        </Form.Control.Feedback>
      </Form.Group>
      <Form.Group className="mb-3">
        <Form.Label className="mb-0">Email</Form.Label>
        <Form.Control
          type="email"
          placeholder="Enter email"
          onChange={handleChange}
          value={values.personalDetails?.email}
          isInvalid={
            touched.personalDetails?.email && !!errors.personalDetails?.email
          }
          onBlur={handleBlur}
          name="personalDetails.email"
        />
        <Form.Control.Feedback type="invalid">
          {errors.personalDetails?.email}
        </Form.Control.Feedback>
      </Form.Group>
      <ValidatingPasswordInput
        label="Password"
        name="personalDetails.password"
        handleChange={handleChange}
        handleBlur={handleBlur}
        value={values.personalDetails.password}
        error={errors.personalDetails?.password}
        touched={touched.personalDetails?.password}
      />
      <ValidatingPasswordInput
        label="Confirm password"
        name="personalDetails.confirmPassword"
        handleChange={handleChange}
        handleBlur={handleBlur}
        value={values.personalDetails.confirmPassword}
        error={errors.personalDetails?.confirmPassword}
        touched={touched.personalDetails?.confirmPassword}
      />
    </>
  );
};

export default PersonalDetailsForm;
